// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/approval_task_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ApprovalTask } from "./approval_task_model_pb";
import { file_bffuser_v1_approval_task_model } from "./approval_task_model_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/approval_task_service.proto.
 */
export const file_bffuser_v1_approval_task_service: GenFile = /*@__PURE__*/
  fileDesc("CiZiZmZ1c2VyL3YxL2FwcHJvdmFsX3Rhc2tfc2VydmljZS5wcm90bxIKYmZmdXNlci52MSIaChhMaXN0QXBwcm92YWxUYXNrc1JlcXVlc3QiTQoZTGlzdEFwcHJvdmFsVGFza3NSZXNwb25zZRIwCg5hcHByb3ZhbF90YXNrcxgBIAMoCzIYLmJmZnVzZXIudjEuQXBwcm92YWxUYXNrMnkKE0FwcHJvdmFsVGFza1NlcnZpY2USYgoRTGlzdEFwcHJvdmFsVGFza3MSJC5iZmZ1c2VyLnYxLkxpc3RBcHByb3ZhbFRhc2tzUmVxdWVzdBolLmJmZnVzZXIudjEuTGlzdEFwcHJvdmFsVGFza3NSZXNwb25zZSIAQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_bffuser_v1_approval_task_model]);

/**
 * @generated from message bffuser.v1.ListApprovalTasksRequest
 */
export type ListApprovalTasksRequest = Message<"bffuser.v1.ListApprovalTasksRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListApprovalTasksRequest.
 * Use `create(ListApprovalTasksRequestSchema)` to create a new message.
 */
export const ListApprovalTasksRequestSchema: GenMessage<ListApprovalTasksRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_task_service, 0);

/**
 * @generated from message bffuser.v1.ListApprovalTasksResponse
 */
export type ListApprovalTasksResponse = Message<"bffuser.v1.ListApprovalTasksResponse"> & {
  /**
   * 申請日時の降順 (= 新しい順) でソート済。
   *
   * @generated from field: repeated bffuser.v1.ApprovalTask approval_tasks = 1;
   */
  approvalTasks: ApprovalTask[];
};

/**
 * Describes the message bffuser.v1.ListApprovalTasksResponse.
 * Use `create(ListApprovalTasksResponseSchema)` to create a new message.
 */
export const ListApprovalTasksResponseSchema: GenMessage<ListApprovalTasksResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_task_service, 1);

/**
 * 承認案件一覧 (= /admin/approval-tasks) を frontend 向けに提供する service。
 * 複数 backend の承認軸を集約する read-only RPC のみを持つ (= mutation は既存の
 * BiddingSpotService / BiddingIntradayService の Transition RPC を再利用)。
 *
 * @generated from service bffuser.v1.ApprovalTaskService
 */
export const ApprovalTaskService: GenService<{
  /**
   * 承認案件 (= 申請済の入札) を業務プロセス横断で一覧取得する。
   * Phase 1 は spot / intraday 入札を fan-out 集約し、 PENDING / APPROVED / REJECTED
   * のみを返す。 ステータス / 業務プロセス / 権限の絞り込みは frontend 側で行う。
   *
   * @generated from rpc bffuser.v1.ApprovalTaskService.ListApprovalTasks
   */
  listApprovalTasks: {
    methodKind: "unary";
    input: typeof ListApprovalTasksRequestSchema;
    output: typeof ListApprovalTasksResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_approval_task_service, 0);

